import {Component, OnInit, Output, EventEmitter, Input, Attribute} from '@angular/core';
import {StsCmsService} from '../../../services/sts-cms-service.service';
import {forkJoin, of} from 'rxjs';

@Component({
  selector: 'app-sts-section-footer',
  templateUrl: 'sts-section-footer.component.html',
  styleUrls: ['sts-section-footer.component.scss']
})
export class StsSectionFooterComponent implements OnInit {

  @Output() renderingComplete = new EventEmitter<boolean>(false);

  public linkStyles = {'font-weight': 'bold'};

  constructor(private cmsService: StsCmsService,
              @Attribute('Prefix') public Prefix,
              @Attribute('needHelpTitle') public needHelpTitle,
              @Attribute('forgotPasswordTitle') public forgotPasswordTitle,
              @Attribute('Suffix') public Suffix,) {
  }

  ngOnInit() {
    let requests = [];
    // if attr is found on template, we'll try to read corresponding label from CMS, otherwise default to empty string
    requests.push(this.Prefix != null ? this.cmsService.getText('sts-homepage-side-Prefix') : of(""));
    requests.push(this.needHelpTitle != null ? this.cmsService.getText('sts-homepage-side-needhelp') : of(""));
    requests.push(this.forgotPasswordTitle != null ? this.cmsService.getText('sts-homepage-side-forgotpassword') : of(""));
    requests.push(this.Suffix != null ? this.cmsService.getText('sts-homepage-side-Suffix') : of(""));
    forkJoin(requests).subscribe(res => {
      this.Prefix = res[0];
      this.needHelpTitle = res[1];
      this.forgotPasswordTitle = res[2];
      this.Suffix = res[3];
    });
  }

}
